<template>
  <router-link
    @click.native="handleLinkClick"
    v-if="show"
    style="color: red; font-size: 12px; margin-left: 15px;"
    :to="`/appShop/appDetail?commodityCode=${currentCommodityCode}`"
    target="_blank"
  >
    {{ randomItem }}
  </router-link>
</template>

<script>
import { interactiveLog } from '@/api/appShop.js';
import store from '@/store/index.js';
import axios from 'axios';
import user from '../../../store/modules/user';
import { isOpen } from '../../../api/interface.js';

export default {
  name: 'goAppShopAppDetail',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      randomItem: '',
    };
  },
  computed: {
    currentCommodityCode() {
      const host = window.location.host;
      if (host === 'pms.qingyingbao.com') {
        return '0511727149937842';
      } else {
        return '0000000000004001';
      }
    },
    show() {
      // 判断是否展示内容
      return false
      return isOpen().then((res) => {
        if (!res.data) {
          this.isShowLable();
          return !res.data;
        }
      });
    },
  },
  methods: {
    isShowLable() {
      // 🔹随机展示的营销标签国际化
      const list = [
        this.$t('appShop.label1'), // 「收款佣金立省25%成本」
        this.$t('appShop.label2'), // 「商家必看！月省千元佣金秘籍」
        this.$t('appShop.label3'), // 「还在为高额提现手续费头疼？」
        this.$t('appShop.label4'), // 「前100名开通领扫码盒子」
        this.$t('appShop.label5'), // 「为什么大品牌都用这个收款？」
        this.$t('appShop.label6'), // 「银行级安全认证｜万家商户的选择」
        this.$t('appShop.label7'), // 「立即申请｜费率立降25%」
        this.$t('appShop.label8'), // 「酒店老板亲述：靠它多赚3千元/月」
      ];
      const randomItem = list[Math.floor(Math.random() * list.length)];
      this.randomItem = randomItem;
    },
    handleLinkClick() {
      // 点击事件埋点
      const { userId, mobile, name } = store.state.user;
      const hotelCode = store.getters.hotelCode;
      const eventParams = { userId, mobile, name, hotelCode };
      let host = window.location.host;
      let url = 'https://t-www.qingyingbao.com/wechat/libra/interactive/log';
      if (host === 'pms.qingyingbao.com') {
        url = 'https://www.qingyingbao.com/wechat/libra/interactive/log';
      }

      axios({
        method: 'post',
        url,
        data: {
          eventId: 'button_click',
          eventParams: JSON.stringify(eventParams).replace('&', '#'),
          page: window.location.href,
          pageName: this.$route.meta.title,
          buttonName: 'go_app_shop_detail_online_pay',
          prevPage: document.referrer,
          platform: 2,
          applicationId: 3,
        },
      })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped></style>
